export const ENTITY_PROFILE_TABS_LOADING_TABS_COUNT = 5

// Cycled over the tab placeholders so the bar reads like titles of varying length.
export const ENTITY_PROFILE_TABS_LOADING_TAB_WIDTHS = [
  96, 168, 120, 144, 104, 132,
]
